<template>
  <div class="tab-table">
    <simple-table 
      category="models"
      :columns="columns"
      :loading="loading"
      :error="error"
      :list="list"
      :inline="true"
      inlineField="title"
      @fetch="handleFetch"
      @create="handleCreate"
      @save="handleSave"
      @remove="handleRemove"
    />
  </div>
</template>

<script>
import SimpleTable from '@/components/common/SimpleTable';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'models-table',

  components: {
    SimpleTable,
  },

  data() {
    return {
      columns: [{ label: 'Название', name: 'title', width: '60%' }],
    };
  },

  watch: {
    params: {
      deep: true,
      handler: function() {
        this.fetch();
      },
    },
  },

  computed: {
    ...mapGetters({
      loading: 'models/loading',
      params: 'indicators/params',
      error: 'models/error',
      list: 'models/list',
    }),
  },

  methods: {
    ...mapActions({
      fetch: 'models/fetch',
      create: 'models/create',
      save: 'models/save',
      remove: 'models/remove',
    }),

    toast(msg, type) {
      if (type === 'success') {
        this.$snotify.success(msg, null, {
          showProgressBar: false,
        });
      }
      if (type === 'error') {
        this.$snotify.error(msg, null, {
          showProgressBar: false,
        });
      }
    },

    handleFetch() {
      this.fetch();
    },

    async handleCreate(value) {
      const err = await this.create({
        title: value,
        status: {
          id: 'published',
        },
      });
      if (!err) {
        this.toast('Модель успешно создана.', 'success');
      } else {
        this.toast('Произошла ошибка.', 'error');
      }
    },

    async handleSave(id, value) {
      const err = await this.save({
        id,
        title: value,
        status: {
          id: 'published',
        },
      });
      if (!err) {
        this.toast('Изменения сохранены.', 'success');
      } else {
        this.toast('Произошла ошибка.', 'error');
      }
    },

    async handleRemove(id) {
      const err = await this.remove({ id });
      if (!err) {
        this.toast('Запись успешно удалена.', 'success');
      } else {
        this.toast('Произошла ошибка.', 'error');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-table {
  display: flex;
  flex-direction: column;
  flex: 1;
}
</style>
